import { createSlice } from '@reduxjs/toolkit'
import { warehouseService } from '../../services/warehouseService'

const initialState = {
	stores: [],
	loading: false,
	error: null,
}

const storeSlice = createSlice({
	name: 'store',
	initialState,
	reducers: {
		getStoresStart: (state) => {
			state.loading = true
		},
		getStoresSuccess: (state, action) => {
			state.loading = false
			state.stores = action.payload
			state.error = null
		},
		getStoresFailure: (state, action) => {
			state.loading = false
			state.error = action.payload
		},
	},
})

export const { getStoresStart, getStoresSuccess, getStoresFailure } = storeSlice.actions

// Thunk action
export const fetchStores = () => async (dispatch) => {
	try {
		dispatch(getStoresStart())
		const response = await warehouseService.getStores()
		dispatch(getStoresSuccess(response))
	} catch (error) {
		dispatch(getStoresFailure(error.message))
	}
}

// Selectors
export const selectStores = (state) => state.store.stores
export const selectStoresLoading = (state) => state.store.loading
export const selectStoresError = (state) => state.store.error

export default storeSlice.reducer
